export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/eae47bf7ccc50446177952a8ae676591.jpg"
          alt="Medical Transportation"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center w-full">
        <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: 'Inter, sans-serif' }}>
          Compassionate Care,<br />Reliable Transport
        </h1>
        <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-3xl mx-auto">
          Professional medical transportation when you need it most
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => scrollToSection('contact')}
            className="px-8 py-4 bg-teal-600/90 text-white rounded-full text-base font-semibold hover:bg-teal-700 transition-all whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            Schedule Ride
          </button>
          <button
            onClick={() => scrollToSection('insurance')}
            className="px-8 py-4 bg-transparent border-2 border-white text-white rounded-full text-base font-semibold hover:bg-white hover:text-teal-600 transition-all whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            Check Coverage
          </button>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 py-8 bg-gradient-to-t from-black/30 to-transparent">
        <h2 className="text-center text-5xl md:text-7xl lg:text-8xl font-black text-white/20 tracking-tight" style={{ fontFamily: 'Inter, sans-serif' }}>
          YOUR JOURNEY TO WELLNESS STARTS HERE
        </h2>
      </div>
    </section>
  );
}
